var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('small',{staticClass:"form-text text-muted topped"},[_vm._v("Updox v2016.0 ˙ © 2020 Updox")])])}]

export { render, staticRenderFns }